export default __webpack_public_path__ + "static/media/isb-dropdown.51e67497.webp";